import type { Action } from "redux";

export type AddToReportClickedEvent = Action<typeof ADD_TO_REPORT_CLICKED>

const addToReportClicked = (): AddToReportClickedEvent => ({
  type: ADD_TO_REPORT_CLICKED
});

export const ADD_TO_REPORT_CLICKED = "add_to_report_clicked";

export default addToReportClicked;
